export enum PredictionType {
    fundusQuality = 'fundusQuality',
    fundusRetinopathyOd = 'fundusRetinopathyOd',
    fundusRetinopathyOs = 'fundusRetinopathyOs',
}
